import type { SentimentThemeMode } from './constants'
import { getSentimentTheme } from './theme'

const ROOT_CLASS = 'sentiment-h5-root'

/** 嵌入原生 webview 时铺满视口，避免 body 黑底只露出中间一条内容 */
export function mountSentimentPageShell(theme: SentimentThemeMode) {
  const tokens = getSentimentTheme(theme)
  const html = document.documentElement
  const body = document.body
  const app = document.getElementById('app')

  html.classList.add(ROOT_CLASS)
  const pageBg = tokens.bg
  html.style.backgroundColor = pageBg
  body.style.backgroundColor = pageBg
  body.style.margin = '0'
  body.style.overflow = 'hidden'
  html.style.overflow = 'hidden'
  body.style.height = '100%'
  html.style.height = '100%'

  if (app) {
    app.style.height = '100%'
    app.style.backgroundColor = pageBg
    app.style.overflow = 'hidden'
  }
}

export function unmountSentimentPageShell() {
  const html = document.documentElement
  const body = document.body
  const app = document.getElementById('app')

  html.classList.remove(ROOT_CLASS)
  html.style.backgroundColor = ''
  html.style.height = ''
  html.style.overflow = ''
  body.style.backgroundColor = ''
  body.style.margin = ''
  body.style.height = ''
  body.style.overflow = ''

  if (app) {
    app.style.height = ''
    app.style.backgroundColor = ''
    app.style.overflow = ''
  }
}
